import React, { createContext, useState } from "react";

export const LayoutContext = createContext({
  fullscreen: false,
  setFullscreen: (_) => {},
});

export const LayoutProvider = ({ children }) => {
  const [fullscreen, setFullscreen] = useState(false);

  return (
    <LayoutContext.Provider
      value={{
        fullscreen,
        setFullscreen,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};
